import React from "react";

import { ConnectionGuide } from "components/Shared/Pages/Settings/SettingsPlatforms/SettingsSmartSearchPinterestModal/ConnectionGuide";

export function PinterestIntegrationModal() {
  return <ConnectionGuide />;
}
